import React from "react"
import { useController } from "react-hook-form"
import { FormFeedback, FormGroup, Input, Label } from "reactstrap"
import PropTypes from "prop-types"
import { t } from "i18next"

function InputRHF(props) {
  const { control, name, label, classNames = {}, ...otherProps } = props
  const { field, fieldState } = useController({ control, name })

  return (
    <FormGroup className={classNames.group}>
      {label ? (
        <Label className={classNames.label} htmlFor={name}>
          {label}
        </Label>
      ) : null}
      <Input
        name={name}
        invalid={fieldState.invalid}
        className={classNames.input}
        {...field}
        {...otherProps}
      />
      {fieldState.error ? (
        <FormFeedback className={classNames.feedback}>
          {t(fieldState.error.message)}
        </FormFeedback>
      ) : null}
    </FormGroup>
  )
}

InputRHF.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  classNames: PropTypes.shape({
    group: PropTypes.string,
    label: PropTypes.string,
    input: PropTypes.string,
    feedback: PropTypes.string,
  }),
}

export default InputRHF
